﻿const rowWidth = {
  init: function() {
    this.smallCta = document.querySelectorAll(
      ".umbraco-forms-footer-cta-small"
    );
    this.bigCta = document.querySelectorAll(
      ".umbraco-forms-bootstrap3-horizontal"
    );

    this.events();
  },

  events: function() {
    for (var wCount = 0; wCount < this.smallCta.length; wCount++) {
      this.firstParent = this.smallCta[wCount].parentNode;
      this.parent = this.firstParent.parentNode;

      this.firstParent.style.margin = "0";
      this.parent.style.maxWidth = "unset";
    }

    for (var wCount = 0; wCount < this.bigCta.length; wCount++) {
      this.firstParent = this.bigCta[wCount].parentNode;
      this.parent = this.firstParent.parentNode;

      this.firstParent.style.margin = "0";
      this.parent.style.maxWidth = "unset";
    }
  }
};

export default rowWidth.init();
